
import Vue from 'vue'
import VueRouter from 'vue-router';

import PCindex from 'src/components/pc/index.vue'
import MobileIndex from 'src/components/mobile/index.vue'
import new1 from 'src/components/news/new1.vue';
import new2 from 'src/components/news/new2.vue';

Vue.use(VueRouter);
const router = new VueRouter({
	routes: [
		{
			name: 'pc',
			path: "/pc/index",
			component: PCindex
		},
		{
			name: 'mobile',
			path: "/mobile/index",
			component: MobileIndex
		}, {
			name: 'new1',
			path: "/new1",
			component: new1
		}, {
			name: 'new2',
			path: "/new2",
			component: new2
		}],
});

export default router